<template>
  <div class="wraper">
    <div class="top-board">
      <div class="top-board-select">
        <span>图表对比</span>
        <el-tooltip placement="right">
          <div slot="content">
            数据统计方式：设备累计值(所有设备数据总和)，平均值(所有设备数据平均值)。
            <br />展示方式：默认展示昨日，最长展示31天，最短展示1天。
            <br />客流数：累计值(所有设备在筛选时间段内累积客流量)，平均值(所有设备在
            <br />筛选时间段内每台平均客流量)。
            <br />平均纯净度：平均值(所有设备在筛选时间段内每台平均纯净度)。
            <br />销售金额：累计值(所有设备在筛选时间段内累积销售金额)，平均值(所有设
            <br />备在筛选时间段内每台平均销售金额)。
            <br />销量：累计值(所有设备在筛选时间段内累积商品销售数量销量)，平均值(所有
            <br />设备在筛选时间段内每台平均商品销售数量)。
          </div>
          <i class="el-icon-question"></i>
        </el-tooltip>
        <el-select v-model="dataType" size="mini" placeholder="请选择">
          <el-option key="sum" label="累计值" value="sum"> </el-option>
          <el-option key="avg" label="平均值" value="avg"> </el-option>
        </el-select>
        <el-date-picker
          v-model="date"
          type="daterange"
          align="right"
          unlink-panels
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="mini"
          :picker-options="pickerOptions2"
        >
        </el-date-picker>
        <el-button type="primary" size="mini" @click="onSubmit">查询</el-button>
      </div>
      <el-row class="top-board-board">
        <el-col :span="6">
          <div class="board-inner">
            <span>客流数</span>
            <span>{{ passengers }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="board-inner">
            <span>平均纯净度</span>
            <span>{{ avgPurity }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="board-inner">
            <span>销售金额</span>
            <span>{{ balance }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="board-inner">
            <span>销量</span>
            <span>{{ sales }}</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-row class="position-relative">
      <div class="title">
        <span>客流量数据</span>
        <el-tooltip placement="right">
          <div slot="content">
            客流数据：默认展示昨日累计值，累计值(所筛选设备在筛选时间段内累积客流量)，
            <br />平均值(所筛选设备在筛选时间段内每台平均客流量)。
          </div>
          <i class="el-icon-question"></i>
        </el-tooltip>
        <el-button type="primary" size="mini" @click="visiblePassengers = true"
          >增加对比指标</el-button
        >
        <el-button type="primary" size="mini" class="fr" @click="exportCustomer"
          >导出报表</el-button
        >
      </div>
      <ve-line
        :data="passengerFlow"
        :settings="passengerFlowSettings"
        :toolbox="toolboxSetting1"
        :grid="gridSetting"
        :colors="colors"
        :extend="extend"
        class="bg-white"
      ></ve-line>
      <!-- <el-button type="primary" class='absolute-btn' @click="visiblePassengers = true">增加对比指标</el-button> -->
    </el-row>
    <el-dialog title="筛选条件" :visible.sync="visiblePassengers" width="50%">
      <dialog-box
        :selectOjb="passengersParams"
        :labelNames="PassengerslabelNames"
        @callFather="handleSun"
      ></dialog-box>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="visiblePassengers = false"
          >取 消</el-button
        >
        <el-button
          size="mini"
          type="primary"
          @click="handleVisiblePassengersPrimary"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-row class="position-relative">
      <div class="title">
        <span>纯净度数据</span>
        <el-tooltip placement="right">
          <div slot="content">
            平均纯净度：平均值(所有设备在筛选时间段内每台平均纯净度)。
          </div>
          <i class="el-icon-question"></i>
        </el-tooltip>
        <el-button type="primary" size="mini" @click="visiblePurity = true"
          >增加对比指标</el-button
        >
        <el-button type="primary" size="mini" class="fr" @click="exportPurity"
          >导出报表</el-button
        >
      </div>
      <ve-line
        :data="purityFlow"
        :settings="purityFlowSettings"
        :toolbox="toolboxSetting2"
        :grid="gridSetting"
        :colors="colors"
        :extend="extend"
        class="bg-white"
      ></ve-line>
      <!-- <el-button type="primary" class='absolute-btn' @click="visiblePurity = true">增加对比指标</el-button> -->
    </el-row>
    <el-dialog title="筛选条件" :visible.sync="visiblePurity" width="50%">
      <dialog-box
        :selectOjb="purityParams"
        :labelNames="puritylabelNames"
        @callFather="handleSun"
      ></dialog-box>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="visiblePurity = false">取 消</el-button>
        <el-button
          size="mini"
          type="primary"
          @click="handleVisiblePurityPrimary"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-row class="position-relative">
      <div class="title">
        <span>销量数据</span>
        <el-tooltip placement="right">
          <div slot="content">
            销量数据：默认展示累计值，累计值(所有设备在筛选时间段内累积商品销售数量销量)，
            <br />平均值(所有设备在筛选时间段内每台平均商品销售数量)。
          </div>
          <i class="el-icon-question"></i>
        </el-tooltip>
        <el-button type="primary" size="mini" @click="visibleSales = true"
          >增加对比指标</el-button
        >
        <el-button type="primary" size="mini" class="fr" @click="exportSaleNum"
          >导出报表</el-button
        >
      </div>
      <ve-line
        :data="salesFlow"
        :settings="salesFlowSettings"
        :toolbox="toolboxSetting3"
        :grid="gridSetting"
        :colors="colors"
        :extend="extend"
        class="bg-white"
      ></ve-line>
      <!-- <el-button type="primary" class='absolute-btn' @click="visibleSales = true">增加对比指标</el-button> -->
    </el-row>
    <el-dialog title="筛选条件" :visible.sync="visibleSales" width="50%">
      <dialog-box
        :selectOjb="salesParams"
        :labelNames="saleslabelNames"
        @callFather="handleSun"
      ></dialog-box>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleSales = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="handleVisibleSalesPrimary" size="mini"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-row class="position-relative">
      <div class="title">
        <span>销售额数据</span>
        <el-tooltip placement="right">
          <div slot="content">
            销售金额数据：默认展示累计值，累计值(所有设备在筛选时间段内累积销售金额)，
            <br />平均值(所有设备在筛选时间段内每台平均销售金额)。
          </div>
          <i class="el-icon-question"></i>
        </el-tooltip>
        <el-button type="primary" size="mini" @click="visibleBalance = true"
          >增加对比指标</el-button
        >
        <el-button
          type="primary"
          size="mini"
          class="fr"
          @click="exportSaleAmount"
          >导出报表</el-button
        >
      </div>
      <ve-line
        :data="balanceFlow"
        :settings="balanceFlowSettings"
        :toolbox="toolboxSetting4"
        :grid="gridSetting"
        :colors="colors"
        :extend="extend"
        class="bg-white"
      ></ve-line>
      <!-- <el-button type="primary" class='absolute-btn' @click="visibleBalance = true">增加对比指标</el-button> -->
    </el-row>
    <el-dialog title="筛选条件" :visible.sync="visibleBalance" width="50%">
      <dialog-box
        :selectOjb="balanceParams"
        :labelNames="balancelabelNames"
        @callFather="handleSun"
      ></dialog-box>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="visibleBalance = false">取 消</el-button>
        <el-button
          size="mini"
          type="primary"
          @click="handleVisibleBalancePrimary"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!--<el-row class='position-relative'>
      <div class="title">
      	<span>畅销商品数据</span>
      	<el-button size='mini' type="primary" class='fr' @click="visibleLiked = true">增加对比指标</el-button>
      </div>
      <ve-line
        :data="likedFlow"
        :settings='likedFlowSettings'
        :toolbox='toolboxSetting5'
        :grid='gridSetting'
        :tooltip='tooltipSetting'
        class="bg-white"
      ></ve-line>
      &lt;!&ndash; <el-button type="primary" class='absolute-btn' @click="visibleLiked = true">增加对比指标</el-button> &ndash;&gt;
    </el-row>
    <el-dialog
      title="筛选条件"
      :visible.sync="visibleLiked"
      width="50%"
    >
      <dialog-box
        :selectOjb='likedParams'
        :labelNames='likedlabelNames'
        @callFather='handleSun'
      ></dialog-box>
      <span slot="footer" class="dialog-footer">
        <el-button size='mini' @click="visibleLiked = false">取 消</el-button>
        <el-button size='mini' type="primary" @click="handleVisibleLikedPrimary">确 定</el-button>
      </span>
    </el-dialog>-->
  </div>
</template>

<script>
import DialogBox from "../home/components/DialogBox";

export default {
  name: "charts",
  components: {
    DialogBox
  },
  data() {
    return {
      extend: {
        series: {
          smooth: false
        },
        xAxis: {
          axisLine: {
            lineStyle: {
              color: "#FFFFFF",
              width: 1 //这里是为了突出显示加上的
            }
          }
        },
        yAxis: {
          axisLine: {
            lineStyle: {
              color: "#FFFFFF",
              width: 1 //这里是为了突出显示加上的
            }
          }
        },
          legend: {
          textStyle: {
            //图例文字的样式
            color: "#fff",
          
          }
        }
      },
      borderUrl: "data/getStatisticalChartIndex",
      lineUrl: "data/getStatisticalChartList",
      exportUrl: "data/exportStatisticalChartList",
      dataType: "sum",
      date: this.getPreDay(),
      passengers: "0",
      avgPurity: "100%",
      balance: "0",
      sales: "0",
      visiblePassengers: false,
      passengersParams: this.params(),
      passengersParamsList: [],
      visiblePurity: false,
      purityParams: this.params(),
      purityParamsList: [],
      visibleBalance: false,
      balanceParams: this.params(),
      balanceParamsList: [],
      visibleSales: false,
      salesParams: this.params(),
      salesParamsList: [],
      visibleLiked: false,
      likedParams: this.params(),
      likedParamsList: [],
      initOptions: {
        renderer: "svg"
      },
      pickerOptions2: {
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, start]);
            }
          },
          {
            text: "最近七天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          }
        ],
        disabledDate(time) {
          return time.getTime() > Date.now() - 1000 * 60 * 60 * 24;
        }
      },
      legendSetting: {
        y: "bottom"
      },
      toolboxSetting1: {
        show: true,
        x: "20px",
        feature: {
          saveAsImage: {
            //保存图片
            show: true,
            name: "客流量图表"
          }
        }
      },
      // tooltipSetting1: {
      //   formatter:function(a,b,c) {
      //     console.log(a)
      //     console.log(b)
      //     console.log(c)
      //   }
      // },
      toolboxSetting2: {
        show: true,
        x: "20px",
        feature: {
          saveAsImage: {
            //保存图片
            show: true,
            name: "纯净度图表"
          }
        }
      },
      toolboxSetting3: {
        show: true,
        x: "20px",
        feature: {
          saveAsImage: {
            //保存图片
            show: true,
            name: "销量图表"
          }
        }
      },
      toolboxSetting4: {
        show: true,
        x: "20px",
        feature: {
          saveAsImage: {
            //保存图片
            show: true,
            name: "销售额图表"
          }
        }
      },
      toolboxSetting5: {
        show: true,
        x: "20px",
        feature: {
          saveAsImage: {
            //保存图片
            show: true,
            name: "畅销商品图表"
          }
        }
      },
      gridSetting: {
        y2: "10px" //top部与x轴的距离
      },
      passengerFlow: {
        columns: ["时间", "默认对比指标"],
        rows: []
      },
      passengerFlowSettings: {
        labelMap: {
          默认对比指标: "默认对比指标"
        },
        legendName: {
          默认对比指标: "默认对比指标：全部设备"
        }
      },
      PassengerslabelNames: {},
      PassengerslabelNamesArr: [],
      purityFlow: {
        columns: ["时间", "默认对比指标"],
        rows: []
      },
      purityFlowSettings: {
        labelMap: {
          默认对比指标: "默认对比指标"
        },
        legendName: {
          默认对比指标: "默认：无设备筛选"
        }
      },
      puritylabelNames: {},
      puritylabelNamesArr: [],
      salesFlow: {
        columns: ["时间", "默认对比指标"],
        rows: []
      },
      salesFlowSettings: {
        labelMap: {
          默认对比指标: "默认对比指标"
        },
        legendName: {
          默认对比指标: "默认对比指标：全部设备"
        }
      },
      saleslabelNames: {},
      saleslabelNamesArr: [],
      balanceFlow: {
        columns: ["时间", "默认对比指标"],
        rows: []
      },
      balanceFlowSettings: {
        labelMap: {
          默认对比指标: "默认对比指标"
        },
        legendName: {
          默认对比指标: "默认：无设备筛选"
        }
      },
      balancelabelNames: {},
      balancelabelNamesArr: [],
      likedFlow: {
        columns: ["时间", "默认对比指标"],
        rows: []
      },
      likedFlowSettings: {
        labelMap: {
          默认对比指标: "默认对比指标"
        },
        legendName: {
          默认对比指标: "默认对比指标：全部设备"
        }
      },
      tooltipSetting: {
        trigger: "axis",
        axisPointer: {
          type: "line"
        },
        formatter: function(params) {
          let tip = params[0].name + "<br/>";
          for (let i = 0; i < params.length; i++) {
            if (params[i].value != 0) {
              console.log(params[i]);
              tip =
                tip +
                params[i].marker +
                params[i].seriesName +
                ":" +
                params[i].value[1] +
                "<br/>";
            }
          }
          return tip;
        }
      },
      likedlabelNames: {},
      likedlabelNamesArr: [],
      colors: [
        "#c23531",
        "#2f4554",
        "#61a0a8",
        "#d48265",
        "#91c7ae",
        "#749f83",
        "#ca8622",
        "#bda29a",
        "#6e7074",
        "#546570",
        "#c4ccd3"
      ]
    };
  },
  mounted() {
    const passengers = JSON.parse(JSON.stringify(this.passengersParams));
    const purity = JSON.parse(JSON.stringify(this.purityParams));
    const balance = JSON.parse(JSON.stringify(this.balanceParams));
    const sales = JSON.parse(JSON.stringify(this.salesParams));
    const liked = JSON.parse(JSON.stringify(this.likedParams));
    this.passengersParamsList.push(passengers);
    this.purityParamsList.push(purity);
    this.balanceParamsList.push(balance);
    this.salesParamsList.push(sales);
    this.likedParamsList.push(liked);
    this.getStatisticalChartIndex();
    this.initData();
  },
  methods: {
    params() {
      return {
        agencyType: "",
        areaCompany: "",
        channelType: "",
        cityCode: "",
        company: "",
        dealerCompany: "",
        group: "",
        marketType: "",
        productModelType: "",
        provinceBranchCompany: "",
        provinceCode: "",
        putPolicy: "",
        secondChannelType: "",
        store: "",
        thirdChannelType: "",
        assetsNum: ""
      };
    },
    initData() {
      this.getFlowData("customer_flow", this.passengersParamsList);
      this.getFlowData("purity", this.purityParamsList);
      this.getFlowData("sales_num", this.salesParamsList);
      this.getFlowData("sales_amount", this.balanceParamsList);
      // this.getFlowData('best_seller_goods', this.likedParamsList);
    },
    onSubmit() {
      this.initData();
      this.getStatisticalChartIndex();
    },
    getPreDay() {
      let date = new Date();
      let startdate = new Date(date.getTime() - 1000 * 60 * 60 * 24 * 8);
      let startyear = startdate.getFullYear();
      let startmonth = startdate.getMonth() + 1;
      if (startmonth < 10) {
        startmonth = "0" + startmonth;
      }
      let startday = startdate.getDate();
      if (startday < 10) {
        startday = "0" + startday;
      }
      startdate = startyear + "-" + startmonth + "-" + startday;
      let enddate = new Date(date.getTime() - 1000 * 60 * 60 * 24);
      let endyear = enddate.getFullYear();
      let endmonth = enddate.getMonth() + 1;
      if (endmonth < 10) {
        endmonth = "0" + endmonth;
      }
      let endday = enddate.getDate();
      if (endday < 10) {
        endday = "0" + endday;
      }
      enddate = endyear + "-" + endmonth + "-" + endday;
      return [startdate, enddate];
    },
    getStatisticalChartIndex() {
      let url = this.borderUrl;
      let params = {
        dataType: this.dataType,
        startDay: this.date[0],
        endDay: this.date[1]
      };
      this.$ajax
        .post(url, params)
        .then(this.getStatisticalChartIndexSucc)
        .catch();
    },
    getStatisticalChartIndexSucc(res) {
      if (res.data && res.data.code === 200) {
        const data = res.data.data;
        this.passengers = data.customerFlow;
        this.avgPurity = data.avgPurity;
        this.balance = "￥" + data.salesAmount;
        this.sales = data.salesNum;
      } else {
        console.log("error");
      }
    },
    getFlowData(flowName, flowList) {
      let _this = this;
      let url = _this.lineUrl;
      let params = [];
      for (let i = 0; i < flowList.length; i++) {
        let temp = {
          fieldName: flowName,
          dataType: _this.dataType,
          startDay: _this.date[0],
          endDay: _this.date[1]
        };
        for (let k in flowList[i]) {
          if (flowList[i][k] != "") temp[k] = flowList[i][k];
        }
        params.push(temp);
      }
      this.$ajax
        .post(url, params)
        .then(function(res) {
          _this.getFlowDataSucc(res, flowName);
        })
        .catch(function(res) {
          console.log(res);
        });
    },
    getFlowDataSucc(res, flowName) {
      if (res.data && res.data.code === 200) {
        const data = res.data.data;
        switch (flowName) {
          case "customer_flow":
            this.handleRes("customer_flow", data);
            break;
          case "purity":
            this.handleRes("purity", data);
            break;
          case "sales_num":
            this.handleRes("sales_num", data);
            break;
          case "sales_amount":
            this.handleRes("sales_amount", data);
            break;
        }
      } else {
        console.log("error");
      }
    },
    handleRes(flowName, res) {
      debugger;
      let name = flowName;
      let data = res;
      let list = [];
      for (let i = 0; i < data.length; i++) {
        let line = data[i];
        if (i === 0) {
          for (let j = 0; j < line.length; j++) {
            list.push({
              时间: line[j].chartX,
              默认对比指标: line[j].chartY
            });
          }
        } else {
          for (let j = 0; j < line.length; j++) {
            list[j]["对比指标" + i] = line[j].chartY;
          }
          let str = "对比指标" + i;
          switch (name) {
            case "customer_flow":
              if (this.passengerFlow.columns.length - 1 === i) {
                this.passengerFlow.columns.push(str);
                this.passengerFlowSettings.labelMap[str] = str;
                this.passengerFlowSettings.legendName[str] =
                  str + " : " + this.PassengerslabelNamesArr[i - 1];
              }
              break;
            case "purity":
              if (this.purityFlow.columns.length - 1 === i) {
                this.purityFlow.columns.push(str);
                this.purityFlowSettings.labelMap[str] = str;
                this.purityFlowSettings.legendName[str] =
                  str + " : " + this.puritylabelNamesArr[i - 1];
              }
              break;
            case "sales_num":
              if (this.salesFlow.columns.length - 1 === i) {
                this.salesFlow.columns.push(str);
                this.salesFlowSettings.labelMap[str] = str;
                this.salesFlowSettings.legendName[str] =
                  str + " : " + this.saleslabelNamesArr[i - 1];
              }
              break;
            case "sales_amount":
              if (this.balanceFlow.columns.length - 1 === i) {
                this.balanceFlow.columns.push(str);
                this.balanceFlowSettings.labelMap[str] = str;
                this.balanceFlowSettings.legendName[str] =
                  str + " : " + this.balancelabelNamesArr[i - 1];
              }
              break;
            default:
              if (this.likedFlow.columns.length - 1 === i) {
                this.likedFlow.columns.push(str);
                this.likedFlowSettings.labelMap[str] = str;
                this.likedFlowSettings.legendName[str] =
                  str + " : " + this.likedlabelNamesArr[i - 1];
              }
          }
        }
      }
      switch (name) {
        case "customer_flow":
          this.passengerFlow.rows = list;
          break;
        case "purity":
          this.purityFlow.rows = list;
          break;
        case "sales_num":
          this.salesFlow.rows = list;
          break;
        case "sales_amount":
          this.balanceFlow.rows = list;
          break;
        default:
          this.likedFlow.rows = list;
      }
    },
    handleVisiblePassengersPrimary() {
      debugger;
      this.visiblePassengers = false;
      let passengers = JSON.parse(JSON.stringify(this.passengersParams));
      let passengerslabel = JSON.parse(
        JSON.stringify(this.PassengerslabelNames)
      );
      this.PassengerslabelNamesArr.push(this.getString(passengerslabel));
      this.passengersParamsList.push(passengers);
      this.getFlowData("customer_flow", this.passengersParamsList); // 获取客流量统计折线图
    },
    handleVisiblePurityPrimary() {
      this.visiblePurity = false;
      let purity = JSON.parse(JSON.stringify(this.purityParams));
      let puritylabel = JSON.parse(JSON.stringify(this.puritylabelNames));
      this.puritylabelNamesArr.push(this.getString(puritylabel));
      this.purityParamsList.push(purity);
      this.getFlowData("purity", this.purityParamsList);
    },
    handleVisibleSalesPrimary() {
      this.visibleSales = false;
      let sales = JSON.parse(JSON.stringify(this.salesParams));
      let saleslabel = JSON.parse(JSON.stringify(this.saleslabelNames));
      this.saleslabelNamesArr.push(this.getString(saleslabel));
      this.salesParamsList.push(sales);
      this.getFlowData("sales_num", this.salesParamsList);
    },
    handleVisibleBalancePrimary() {
      this.visibleBalance = false;
      let balance = JSON.parse(JSON.stringify(this.balanceParams));
      let balancelabel = JSON.parse(JSON.stringify(this.balancelabelNames));
      this.balancelabelNamesArr.push(this.getString(balancelabel));
      this.balanceParamsList.push(balance);
      this.getFlowData("sales_amount", this.balanceParamsList);
    },
    handleVisibleLikedPrimary() {
      this.visibleLiked = false;
      let liked = JSON.parse(JSON.stringify(this.likedParams));
      let likedlabel = JSON.parse(JSON.stringify(this.likedlabelNames));
      this.likedlabelNamesArr.push(this.getString(likedlabel));
      this.likedParamsList.push(liked);
      this.getFlowData("best_seller_goods", this.likedParamsList);
    },
    getString(names) {
      let passengerslabel = JSON.parse(JSON.stringify(names));
      let str = "";
      for (let k in passengerslabel) {
        str += passengerslabel[k] + ";";
      }
      return str;
    },
    handleSun() {},
    exportFlowData(flowName, flowList) {
      let _this = this;
      let url = _this.exportUrl;
      let params = [];
      for (let i = 0; i < flowList.length; i++) {
        let temp = {
          fieldName: flowName,
          dataType: _this.dataType,
          startDay: _this.date[0],
          endDay: _this.date[1]
        };
        for (let k in flowList[i]) {
          if (flowList[i][k] != "") temp[k] = flowList[i][k];
        }
        params.push(temp);
      }
      this.$ajax({
        method: "post",
        url: url,
        data: params,
        responseType: "blob"
      })
        .then(res => {
          console.log(res);
          const link = document.createElement("a");
          let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          if (flowName == "sales_num") {
            flowName = "销量数据" + _this.date[0] + "至" + _this.date[1];
          } else if (flowName == "sales_amount") {
            flowName = "销售额数据" + _this.date[0] + "至" + _this.date[1];
          } else if (flowName == "purity") {
            flowName = "纯净度数据" + _this.date[0] + "至" + _this.date[1];
          } else if (flowName == "customer_flow") {
            flowName = "客流量数据" + _this.date[0] + "至" + _this.date[1];
          }
          link.setAttribute("download", flowName + ".xlsx");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch(function(res) {
          console.log(res);
        });
    },
    exportSaleNum() {
      this.exportFlowData("sales_num", this.salesParamsList);
    },
    exportSaleAmount() {
      this.exportFlowData("sales_amount", this.balanceParamsList);
    },
    exportPurity() {
      this.exportFlowData("purity", this.purityParamsList);
    },
    exportCustomer() {
      this.exportFlowData("customer_flow", this.passengersParamsList); // 获取客流量统计折线图
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.absolute-btn {
  position: absolute;
  bottom: 10px;
  left: 10px;
}

.position-relative {
  position: relative;
}

.title {
  padding: 10px;
  height: 40px;
  line-height: 40px;
}

.bg-white {
  /* background: #fff; */
  background: rgba(0, 0, 0, 0.25);
}

.board-inner {
  margin: 0 5px;
  /* background: #2c7bcc; */
  background: rgba(0, 0, 0, 0.25);
  color: #fff;
  text-align: center;
  line-height: 2;
  padding: 10px 0;
}

.board-inner span {
  display: block;
}

.top-board-board {
  height: 104px;
  padding: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/charts/charts.vue